import React, { useEffect, useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTablePagination,
} from "../../../Common/DataTable";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  deleteSubscriber,
  getSubscriberList,
  rowSorting,
} from "../../../store/actions";
import Filters from "./Filters";
import { toast } from "react-toastify";
import moment from "moment/moment";

const columnData = [
  { id: "_id", align: false, disablePadding: true, label: "#", order: 1 },
  {
    id: "email",
    align: false,
    disablePadding: true,
    label: "Email",
    title: "Email",
    order: 1,
  },
  {
    id: "action",
    align: true,
    disablePadding: false,
    title: "action",
    label: "Action",
  },
];
const SubscribersIndex = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const [filterBy, setFilterBy] = useState("email");
  const [dragUsers, setDragUsers] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [state, setState] = useState({
    orderBy: "sort_index",
    order: "asc",
    page: 0,
    limit: 10,
    searchBy: "email",
    search: "",
  });
  const subscriberData = useSelector((s) => s.Signatures?.subscribers?.data);
  const loading = useSelector((s) => s.Signatures?.loading);
  const totalCount = useSelector((s) => s.Signatures?.subscribers?.total_count);

  useEffect(() => {
    if (subscriberData) {
      setDragUsers(subscriberData);
    }
  }, [subscriberData]);

  useEffect(() => {
    dispatch(getSubscriberList(state));
  }, [state]);
  const handleStatus = (e) => {
    e.preventDefault();
    const { value } = e.target;
    setFilterBy(value);
  };

  const filterdata = (e) => {
    e.preventDefault();
    let body = {
      ...state,
      search: filter,
      searchBy: filterBy,
    };
    dispatch(getSubscriberList(body));
  };

  const resetFilter = () => {
    setState((pre) => ({
      ...pre,
      search: "",
    }));
    setFilter("");
  };

  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setFilter(value);
  };

  const handleChangePage = (event, page) => {
    setState((pre) => ({
      ...pre,
      page: page,
    }));
  };

  const handleDragEnd = (e) => {
    if (!e.destination) return;
    let tempData = Array.from(dragUsers);
    let [source_data] = tempData.splice(e.source.index, 1);
    tempData.splice(e.destination.index, 0, source_data);
    setDragUsers(tempData);

    let body = {
      id: e?.draggableId,
      current_index: JSON.stringify(e?.source?.index + 1),
      destination_index: JSON.stringify(e?.destination?.index + 1),
      action_on: "subscribers",
    };
    dispatch(rowSorting(body));
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = dragUsers.map((item) => item.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  const handleCheckboxChange = (event, id) => {
    if (event.target.checked) {
      setSelectedRows([...selectedRows, id]);
    } else {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    }
  };

  const handleDeleteSocial = (e) => {
    e.preventDefault();
    const callBack = (res) => {
      if (res.data.message == "success") {
        toast.success("Deleted Successfully!");
        dispatch(getSubscriberList(state));
      }
    };
    dispatch(deleteSubscriber({ ids: selectedRows }, callBack));
  };

  useEffect(() => {
    var csvData = [
      ["First Name", "Last Name", "Email", "Phone", "Message", "Date Created"],
    ];
    dragUsers?.length > 0 &&
      dragUsers?.map((item) =>
        csvData.push([
          item.email,
          moment(item.created_at).format("DD/MM/YYYY hh:mm:ss"),
        ])
      );
    setExportData(csvData);
  }, [dragUsers]);

  return (
    <>
      <section className="dashboard py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="top mb-2">
                <h4 className="dashboard-head m-0">Subscribers</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Filters
                status={state.status}
                columns={state.columns}
                filter={filter}
                handleStatus={handleStatus}
                handleSearchChange={handleSearchChange}
                filterdata={filterdata}
                resetFilter={resetFilter}
                handleDeleteSocial={handleDeleteSocial}
                selectedRows={selectedRows}
                csvData={exportData}
              />
              <div className="bg-white px-4 py-3 card-box">
                <div className="table-responsive py-3">
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <DataTable className="">
                      <DataTableHead
                        columns={columnData}
                        orderBy={state.orderBy}
                        //   sort={handleRequestSort}
                        isCheckbox={true}
                        handleSelectAll={handleSelectAll}
                        selectedRows={selectedRows}
                        tableData={dragUsers}
                      />
                      <Droppable droppableId="droppable-1">
                        {(provider) => (
                          <DataTableBody
                            loading={loading}
                            column={columnData}
                            data={dragUsers}
                            page={state.page}
                            rowsPerPage={state.limit}
                            innerRef={provider.innerRef}
                            dropProp={provider.droppableProps}
                            isCheckbox={true}
                            handleCheckboxChange={handleCheckboxChange}
                            selectedRows={selectedRows}
                            actionBtn={[
                              {
                                label: "View",
                                icon: "",
                                link: "/subscribers/detail",
                              },
                            ]}
                          />
                        )}
                      </Droppable>
                    </DataTable>
                  </DragDropContext>
                  <div className="custom-pagination d-flex align-items-center w-100 justify-content-end">
                    <div className="main-pagination-drop d-flex gap-2 align-items-center">
                      <h6 className="row-per-page-heading m-0">
                        Rows per page:
                      </h6>
                      <Dropdown>
                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                          {state.limit}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 10 }))
                            }
                          >
                            10
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 25 }))
                            }
                          >
                            25
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 50 }))
                            }
                          >
                            50
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              setState((pre) => ({ ...pre, limit: 100 }))
                            }
                          >
                            100
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    {dragUsers?.length > 0 && (
                      <DataTablePagination
                        count={totalCount}
                        rowsPerPage={state.limit}
                        page={state.page}
                        onPageChange={handleChangePage}
                        rowsPerPageOptions={[]}
                      />
                    )}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SubscribersIndex;
